import styled from "styled-components";
import { responsive } from "../../styles/constants.style";

export const MdmViewActivityWrapper = styled.div`
  .activity-details-grid {
    padding: 0px 16px 40px 16px;
  }

  .cell-topic {
    min-width: 250px;
  }

  .MuiAccordion-root {
    margin-bottom: 16px;
  }

  .topic-details-grid {
    padding: 16px;
    ${responsive.MOBILE`
           padding: 16px 0px 16px 0px;
         `}
  }
`;
